import { Whisper, Tooltip } from 'rsuite';
import { TableCell } from '@mui/material';
import { Avatar } from '@shared/ui/parts';

export function MemberTeamsAvatar({ row }) {
  return (
    <div className="memberTeamsCell">
      {row.groups?.map((group) => (
        <Whisper
          placement="auto"
          controlId="control-id-hover"
          trigger="hover"
          key={group.id}
          speaker={<Tooltip>{group.name}</Tooltip>}
        >
          <div className="teamCell__avatar">
            <Avatar team={group} />
          </div>
        </Whisper>
      ))}
    </div>
  );
}

export default function MemberTeamsCell({ row }) {
  return (
    <TableCell>
      <MemberTeamsAvatar row={row} />
    </TableCell>
  );
}
